import { createAPI } from '@common'

export default {
  // 会员数概览
  count: config => createAPI('customEncryptApiName-1/0w20ojt0vd0dpvou', 'get', config),
  // 查询服务日志列表
  delete: config => createAPI('customEncryptApiName-1/0w20ojt0vd0efmfuf', 'post', config)
}
